import { getSessionContext, getUsers, updateSessionContext } from '@/endpoints'
import { SessionContextDto,UserDto } from '@/endpoints/models'
import { RootState } from '@/store'
import { apiCallAction, AppDispatch } from '@/store/utils'

import { getNodeSession } from '../node'
import { getSettingsSession } from '../settings'
import { getTabSession } from '../tab'
import { SESSION_VERSION, UserSession } from '.'
import {
	USER_CONTEXT_LOADED,
	USER_DIALOG_SETTINGS_UPDATE,
	USER_DIALOG_SIZE_CHANGED,
	USER_GET,
	USER_LIST_GET,
} from './constants'
import { DialogSettings } from './types'

interface LoadUser {
	payload: UserDto,
	type: typeof USER_GET
}

interface DialogSettingsAction {
	payload: DialogSettings,
	type: typeof USER_DIALOG_SETTINGS_UPDATE
}

interface LoadUserList {
	payload: UserDto[],
	type: typeof USER_LIST_GET
}

interface UserContextLoaded {
	payload: SessionContextDto,
	type: typeof USER_CONTEXT_LOADED
}

interface DialogSizeChanged {
	dialogId: string,
	height: number,
	isMaximized: boolean,
	type: typeof USER_DIALOG_SIZE_CHANGED,
	width: number
}

export const loadUsers = () =>
	apiCallAction<LoadUserList>(() => getUsers(), USER_LIST_GET)

export const loadUserSession = () =>
	apiCallAction<UserContextLoaded>(
		() => getSessionContext(),
		USER_CONTEXT_LOADED,
	)

/** Set session from an already-fetched context (e.g. from App bootstrap). Avoids duplicate getSessionContext. */
export const setSessionContext = (payload: SessionContextDto): UserContextLoaded => ({
	type: USER_CONTEXT_LOADED,
	payload,
})

export const updateUserSession =
	(lastData: string | null) =>
	async (dispatch: AppDispatch, getValues: () => RootState): Promise<any> => {
		const data = JSON.stringify({
			__version: SESSION_VERSION,
			node: getNodeSession(getValues().node),
			tab: getTabSession(getValues().tab),
			settings: getSettingsSession(getValues().settings),
			dialog: getValues().user.dialog,
		} as UserSession)

		if (data !== lastData) {
			return dispatch(
				apiCallAction(() => updateSessionContext({ context: data })),
			)
		}

		return { context: lastData }
	}

export const saveDialogSize = (
	dialogId: string,
	width: number,
	height: number,
	isMaximized: boolean,
): Actions => ({
	type: USER_DIALOG_SIZE_CHANGED,
	dialogId,
	width,
	height,
	isMaximized,
})

export const updateDialogSettings = (
	settings: DialogSettings,
): DialogSettingsAction => ({
	type: USER_DIALOG_SETTINGS_UPDATE,
	payload: settings,
})

export type Actions =
	| LoadUser
	| LoadUserList
	| UserContextLoaded
	| DialogSizeChanged
	| DialogSettingsAction
